import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { MdbModalRef } from 'src/lib/mdb5-adapted/public-api';
import { MdbRippleModule } from 'src/lib/mdb5-adapted/public-api';
import { AppUtilityService } from 'src/app/app-utility.service';
import { LmsModalFrameComponent } from '../../ui/lms-modal-frame/lms-modal-frame.component';

@Component({
  selector: 'app-maximum-loans-dialog',
  templateUrl: './maximum-loans-dialog.component.html',
  styleUrls: ['./maximum-loans-dialog.component.scss'],
  imports: [CommonModule, LmsModalFrameComponent, MdbRippleModule],
  standalone: true,
})
export class MaximumLoansDialogComponent implements OnInit {
  clientType: string;
  wageFrequency: string; //:any;

  constructor(
    public global_utility: AppUtilityService,
    public dialogRef: MdbModalRef<MaximumLoansDialogComponent>)
  {}

  ngOnInit(): void {
    console.log('wageFrequency = '+ this.wageFrequency);
  }
  close() {
    this.dialogRef.close();
    //return this.dialogRef.close(this.employmentDetailsForm.value);
  }
}
